import React from 'react';
import {
	emailValidationScheme,
	numericIntervalValidationScheme,
	requiredPhoneValidation,
	stringRequiredValidationScheme
} from '@utils/validation';
import { object, string } from 'yup';
import {
	ConnectorIndexEnum,
	CustomAuthConnector,
	CONNECTORS_FORM_KEYS,
	IFormikValues
} from 'types/connectors';
import { ITheme } from 'types/theme';
import { SendgridEditForm, SmtpEditForm, TwilioEditForm } from './Dialogs';

const { SENDGRID, SMTP, TWILIO } = ConnectorIndexEnum;

export const getConnectorForm = (
	connector: CustomAuthConnector,
	formik: IFormikValues
) => {
	const props = {
		gridSpacing: 2,
		formik
	};

	switch (connector.providerProtocol) {
		case SENDGRID:
			return <SendgridEditForm {...props} />;
		case SMTP:
			return <SmtpEditForm {...props} />;
		case TWILIO:
			return <TwilioEditForm {...props} />;
		default:
			return [];
	}
};

export const getConnectorFormValidations = ({
	providerProtocol
}: CustomAuthConnector) => {
	const {
		serviceName,
		apiKey,
		fromEmail,
		port,
		username,
		accountSid,
		messagingServiceSid,
		apiSecret,
		authToken,
		fromPhone,
		selectedProp,
		selectedAuthProp,
		methodApiSecret,
		methodAuthToken
	} = CONNECTORS_FORM_KEYS;

	const SendgridValidations = object({
		[serviceName]: stringRequiredValidationScheme(),
		[apiKey]: stringRequiredValidationScheme(),
		[fromEmail]: emailValidationScheme(true)
	});

	const SmtpValidations = object({
		[serviceName]: stringRequiredValidationScheme(),
		[port]: numericIntervalValidationScheme(),
		[username]: stringRequiredValidationScheme(),
		[fromEmail]: emailValidationScheme(true)
	});

	const TwilioValidations = object({
		[serviceName]: stringRequiredValidationScheme(),
		[authToken]: string().when(selectedAuthProp, {
			is: (val: string) => val === methodAuthToken,
			then: stringRequiredValidationScheme()
		}),
		[apiKey]: string().when(selectedAuthProp, {
			is: (val: string) => val === methodApiSecret,
			then: stringRequiredValidationScheme()
		}),
		[apiSecret]: string().when(selectedAuthProp, {
			is: (val: string) => val === methodApiSecret,
			then: stringRequiredValidationScheme()
		}),
		[accountSid]: string().when(selectedProp, {
			is: (val: string) => val === messagingServiceSid,
			then: stringRequiredValidationScheme()
		}),
		[fromPhone]: string().when(selectedProp, {
			is: (val: string) => val === fromPhone,
			then: requiredPhoneValidation()
		})
	});

	switch (providerProtocol) {
		case SENDGRID:
			return SendgridValidations;
		case SMTP:
			return SmtpValidations;
		case TWILIO:
			return TwilioValidations;
		default:
			return {};
	}
};
export const getConnectorIcon = (
	type: ConnectorIndexEnum | 'descope',
	theme: ITheme
) => {
	const { assets } = theme;
	const { descope, connectors } = assets;
	const { SmtpIcon, SendGridIcon, TwilioIcon } = connectors;
	switch (type) {
		case 'descope':
			return descope.DescopeLogoSymbol();
		case ConnectorIndexEnum.SENDGRID:
			return SendGridIcon();
		case ConnectorIndexEnum.TWILIO:
			return TwilioIcon();
		default:
			return SmtpIcon();
	}
};
